<script setup lang="ts">
import axios from 'axios';
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { API_URL } from '@idem/common/constantes';

const apiBaseUrl = API_URL || '/api';
const router = useRouter();
const actividades = ref<any[]>([]);

try {
  const response = await axios.get(`${apiBaseUrl}/super/actividades/publicadas`);
  actividades.value = response.data;
} catch (e: any) {
  if (e.status === 401 || e.response?.status === 401) {
    await router.push('/login');
  }
}
</script>

<template>
  <section class="mx-auto max-w-6xl px-4 py-8">
    <header class="mb-6 flex items-center justify-between">
      <div>
        <h1 class="text-3xl font-bold tracking-tight text-gray-900">
          Administración de Actividades Publicadas
        </h1>
        <p class="mt-1 text-sm text-gray-500">
          Supervisa y edita las actividades publicadas en la plataforma.
        </p>
      </div>
      <router-link
        to="/actividades/visar"
        class="rounded-md bg-gray-100 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-200"
      >
        Ir a Actividades por Visar
      </router-link>
    </header>

    <div v-if="actividades.length" class="space-y-4">
      <div
        v-for="actividad in actividades"
        :key="actividad.id"
        class="flex flex-col justify-between gap-4 rounded-xl border border-gray-200 bg-white p-5 shadow-sm sm:flex-row sm:items-center"
      >
        <div>
          <h2 class="text-xl font-semibold text-gray-900">{{ actividad.nombre }}</h2>
          <p v-if="actividad.nombreEmpresa" class="text-sm font-medium text-teal-600">
            {{ actividad.nombreEmpresa }}
          </p>
          <div class="mt-2 flex flex-wrap gap-3 text-sm text-gray-600">
            <span>📅 {{ actividad.fecha }} {{ actividad.hora }}</span>
            <span v-if="actividad.direccion">📍 {{ actividad.direccion }}</span>
          </div>
        </div>
        <div>
          <router-link
            :to="`/actividades/admin/${actividad.id}`"
            :data-testid="`boton-editar-${actividad.id}`"
            class="inline-flex items-center rounded-lg bg-teal-600 px-4 py-2 text-sm font-medium text-white hover:bg-teal-700"
          >
            Editar
          </router-link>
        </div>
      </div>
    </div>

    <div
      v-else
      class="rounded-lg border border-dashed border-gray-300 p-10 text-center"
      data-testid="mensaje-vacio"
    >
      <p class="text-gray-500">No hay actividades publicadas en este momento.</p>
    </div>
  </section>
</template>
